import { UrlMatcher, UrlSegment } from '@angular/router';

import { shouldPrefixWithActiveOrgSegment } from '../utils/org-prefix-route.util';

export const OrganizationRouteMatcher: UrlMatcher = (segments: UrlSegment[]) => {
  const firstSegment = segments[0]?.path;
  if (!shouldPrefixWithActiveOrgSegment(firstSegment)) return null;
  return { consumed: segments };
};
